import React from "react";

// Component created cause was needed to be implemented after whole component was developed

const Selector = ({ selector, handleSelectedRange }) => {
  const { text, value, active } = selector;
  return (
    <button
      data-button-type={active ? "primary" : "secondary"}
      onClick={() => handleSelectedRange(value)}
    >
      {text}
    </button>
  );
};

// The component works based on weeks number. Since whe have weeks or months options, we can use weeks as a base
// We split it by 4 to get months
export const IndependentDateRangeComponent = ({
  weeksSelected,
  handleSelectedRange,
  classNames,
}) => {
  const selectors = [
    {
      key: "2weeks",
      text: "2 weeks",
      value: 2,
      active: weeksSelected === 2,
    },
    {
      key: "1month",
      text: "1 month",
      value: 4,
      active: weeksSelected === 4,
    },
    {
      key: "3month",
      text: "3 month",
      value: 12,
      active: weeksSelected === 12,
    },
    {
      key: "6month",
      text: "6 month",
      value: 24,
      active: weeksSelected === 24,
    },
    {
      key: "lifetime",
      text: "Lifetime",
      value: 0,
      active: weeksSelected === 0,
    },
  ];

  return (
    <div className={`selector-container ${classNames}`}>
      {selectors.map((selector, idx) => (
        <Selector
          key={`range-selector-${idx}`}
          selector={selector}
          handleSelectedRange={handleSelectedRange}
        />
      ))}
    </div>
  );
};
